<template>
	<div v-if="usuario.ID">
		<div class="menuppal p-2 m-0 text-center">
			<img :src="usuario.avatar" style="width:100px;height:100px;" alt="" class="rounded-circle mb-2">
			<br>
			<b>{{usuario.nombre}}</b>
			<br>
			<div class="btn-group mt-2">
				<button class="btn btn-light" title="Fichar" @click="fichar()" v-if="permisos.gestion_jornada_acceder">
					<span class="fa fa-w fa-address-card"></span>
				</button>
				<button class="btn btn-light" title="Mi perfil de usuario" @click="verPerfil()">
					<span class="fa fa-w fa-user"></span>
				</button>
				<router-link to="/main/panel-control" class="btn btn-light" title="Ajustes">
					<span class="fa fa-w fa-gear"></span>
				</router-link>
				<router-link to="/main" class="btn btn-light" title="Muro">
					<span class="fa fa-w fa-home"></span>
				</router-link>
				<button class="btn btn-warning" title="Bloquear sesión" @click="lock()">
					<span class="fa fa-w fa-lock"></span>
				</button>
				<button class="btn btn-danger" title="Cerrar sesión" @click="logout()">
					<span class="fa fa-w fa-sign-out"></span>
				</button>
			</div>
			<div class="mt-2 p-3 bg-danger text-white" v-if="externo" style="margin-left:-6px;margin-right:-6px;margin-bottom:-6px;">
				<span class="fa fa-exclamation-circle mr-2"></span><b>Acceso externo</b>
				<br>
				{{ip}}
			</div>
			<div class="mt-2 p-3 bg-success text-white" v-if="!externo" style="margin-left:-6px;margin-right:-6px;margin-bottom:-6px;">
				<span class="fa fa-lock mr-2"></span><b>Acceso seguro</b>
				<br>
				{{ip}}
			</div>
		</div>
		<menu-item v-for="item in menuItems" :key="item.nombre" :item="item"></menu-item>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuItem from './menu-item'
import axios from 'axios'

export default {
	name: 'sidebar',
	components: {
		'menu-item': MenuItem
	},

	data: function () {
		return {
			menuItems: [],
			timer: null
		}
	},

	created () {
		// FIX: A veces hay que pedir el menú con ciertro retraso para que cargue
		window.setTimeout(() => {
			this.getMenu()
		}, 300)

		this.timer = window.setInterval(() => {
			if (this.usuario && this.usuario.ID) {
				this.getMenu()
			}
		}, 30000)

		this.$store.watch(
			(a) => a.session.activa,
			(newValue, oldValue) => {
				if (newValue && !oldValue) {
					this.getMenu()
				}
			})

		this.$store.watch(
			(a) => a.session.bloqueado,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.getMenu()
				}
			})
	},

	beforeDestroy () {
		window.clearInterval(this.timer)
	},

	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			externo: 'session/externo',
			ip: 'session/ip',
			permisos: 'permisos/permisos'
		})
	},

	methods: {
		getMenu () {
			axios.get('core/php/api/menu/get-menu.php')
				.then(res => {
					this.menuItems = res.data.menu.items
				})
				.catch(e => {
					if (e.message && e.message.code === 423) {
						return
					}
					this.$store.commit('toast/danger', {
						titulo: 'Error consultando el menú',
						mensaje: (e.response && e.response.data && e.response.data.error) ? e.response.data.error : ''
					})
				})
		},
		logout () {
			this.$store.dispatch('session/logout')
			window.setTimeout(() => {
				this.$router.push('/login')
			}, 300)
		},
		verPerfil () {
			this.$emit('verperfil')
		},
		lock () {
			this.$store.dispatch('session/lock')
		},
		fichar () {
			this.$emit('fichar')
		}
	}
}
</script>


<style scoped>
	.menuppal	{
		background-color: #3D4553;
		color: white;
	}
	.cat {
		position: relative;
		display: block;
		border-bottom: 1px solid #e0e0e0;
		padding: 5px;
		margin: 0;
		list-style-type: none;
	}

	.cat > li {
		list-style-type: none;
		position: relative;
		display: block;
		padding: 0;
		margin: 0;
		padding-left: 5px;
	}
</style>




// WEBPACK FOOTER //
// src/modulos/core/vue/components/main/sidebar.vue